import { render, staticRenderFns } from "./createEmailTemplate.vue?vue&type=template&id=850b368e&"
import script from "./createEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./createEmailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports